exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".applicant-payment .verification_required{display:block;max-width:100px;margin-left:auto;margin-right:auto}.applicant-payment .start-verification p{text-align:center;max-width:470px;margin-left:auto;margin-right:auto}.applicant-payment .start-verification p a{color:#3ec19d;font-weight:600}.applicant-payment .start-verification a.continue{display:block;max-width:260px;padding:10px 0;border:2px solid #3ec19d;background:#3ec19d;border-radius:2px;text-decoration:none;font-size:16px;color:#fff;text-align:center;margin-top:50px;margin-left:auto;margin-right:auto;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/payment/start/start.scss
// module id = 1169
// module chunks = 0